<template>
    <v-dialog
        v-model="$store.state.concil.customerSelection"
        max-width="600px"
        persistent
        transition="dialog-bottom-transition"
    >
        <v-card
            elevation="2"
            outlined
            style="padding: 40px;"
        >
            <v-container fluid>
                <v-card-title style="padding: 0 0 20px;">
                    Please choose a customer to open reconciliation
                </v-card-title>
                <v-row>
                    <v-col
                        cols="12"
                    >
                        <v-select
                            v-model="selectedCustomer"
                            :items="customerList"
                            item-text="Name"
                            item-value="Value"
                            label="Select a customer"
                            outlined
                            @change="handleCustomerSelection"
                            hide-details
                            return-object
                            dense
                        ></v-select>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
    // Imports here

    export default {
        props: [],
        components: {
        },
        data: function() {
            return {
                selectedCustomer: null,
                customerList: [
                    {
                        Name: "Circle K",
                        Alias: "CK",
                        Value: 1,
                        MultipleImport: false,
                    },
                    {
                        Name: "Suncor",
                        Alias: "Suncor",
                        Value: 2,
                        MultipleImport: false,
                    },
                    {
                        Name: "Mr. Gas",
                        Alias: "MrGas",
                        Value: 3,
                        MultipleImport: false,
                    },
                    {
                        Name: "CP Rail",
                        Alias: "CPRail",
                        Value: 4,
                        MultipleImport: true,
                    },
                    {
                        Name: "KAG",
                        Alias: "KAG",
                        Value: 5,
                        MultipleImport: false,
                    },
                    {
                        Name: "Parkland",
                        Alias: "Parkland",
                        Value: 6,
                        MultipleImport: false,
                    },
                    {
                        Name: "Shell CP",
                        Alias: "ShellCP",
                        Value: 7,
                        MultipleImport: false,
                    },
                    {
                        Name: "Valero",
                        Alias: "Valero",
                        Value: 8,
                        MultipleImport: false,
                    },
                    {
                        Name: "BP Products",
                        Alias: "BPProducts",
                        Value: 9,
                        MultipleImport: false,
                    },
                ],
            }
        },
        mounted() {
            //this.functionsForMountedHere();
        },
        methods: {
            handleCustomerSelection: function() {
                console.log("Selected Customer: ", this.selectedCustomer);
                this.$emit('close', this.selectedCustomer);
                this.$store.state.concil.customerSelection = false;
            },
        },
    };
</script>

<style>
</style>